import React from 'react';
import Bootstrap from '../bootstrap';
import MicroComponent from '../common/MicroComponent';
import ParkRegisNorthQuayOffering from '../../pactum-server/stubs/offeringFactory';

const RoomDetails: React.FC = () => {
  const args = {
    product: ParkRegisNorthQuayOffering({}),
    onAction: () => alert('closeMe'),
  };

  return (
    <Bootstrap>
      <MicroComponent micro={{ sdkName: SERVICE_SDK_NAME, componentName: 'RoomDetails' }} {...args} />
    </Bootstrap>
  );
};

export default RoomDetails;
